import React, { Component } from 'react'; 
import {Table, Row, Col, Button, Pagination, FormControl} from 'react-bootstrap';
import _ from 'lodash';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; // Include CSS

function searchingFor(filterRows){
	return function(x){
      let key = _.keys(filterRows)
      let newObj =[]
      if(!_.isEmpty(key)){        
       _.map(key, (gg) =>{  
        if(!_.isNull(x[gg])){
          if(typeof x[gg] === "string"){
            newObj.push(x[gg].toLowerCase().includes(filterRows[gg].toLowerCase()))
          } else {
            newObj.push(x[gg].toString().includes(filterRows[gg].toString()))
          }
        }
      })
    }
    if(!_.isEmpty(newObj)){
      return !_.includes(newObj, false)
    } else {
       return true
    }
  }
}
export default class ViewMapping extends Component {
	constructor(props){
    super(props)
    this.state=this.getInitialState()
	}
	getInitialState = () => {
		return {
			selectedauditors:[],
			show:false,
			activePage: 1,
			filterRows:{},
		}
	}

	handleSelectAuditors = (e) => {
		this.setState({selectedauditors: e});
		if(!_.isEqual(this.state.selectedauditors, e)){
			this.setState({show:false})
		}
	}
	validateButton = () => {
	const {selectedauditors} = this.state;
    if(!_.isEmpty(selectedauditors)){
       return true;
    }
	}
	showMappedAgents = () => {
		this.setState({show:true})
		this.props.action.MappedAgentsListView({'auditorId':this.state.selectedauditors.employeeId})
	}
	reset = () => {
		this.setState(this.getInitialState())
	}
	handleSelectPagination = (eventKey) => {
    this.setState({
      activePage: eventKey,
    });
	}
	handleSelectPaginationPrev = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage-1,
    });
	}
	handleSelectPaginationNext = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage+1,
    });
  }
	handleFilter = () =>{
		this.setState((prevState) =>{
		return {showFilter: !prevState.showFilter};
		})
		if(!_.isNull(this.state.filterRows)){
		let keys = _.keys(this.state.filterRows)
		_.map(keys, (obj) =>{
		this.setState({[obj]:""})
		})
		this.setState({filterRows:{}})
		}
	}
	handleChange = (e) => {
		const {filterRows} = this.state
		let filterCol = filterRows
		if(_.has(filterCol, e.target.id)){
		  filterCol[e.target.id]  = e.target.value
		} else {
		  filterCol = Object.assign(filterCol, {[e.target.id]:e.target.value})
		}
		this.setState({[e.target.id]:e.target.value, filterRows:filterCol})	
	  }



	render(){		
		const {show, activePage, showFilter, filterRows} = this.state;
		const {mappedAgentList} = this.props;
		const Per_Page=100;
    let totalPages;
    if(!_.isEmpty(mappedAgentList)){
     totalPages = Math.ceil(mappedAgentList.length/Per_Page)
    }
		const startOffset = (this.state.activePage-1) * Per_Page;
		let startCount = 0;
		let items = [];
		for (let number = 1; number <= totalPages; number++) {
			items.push(
				<Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
					{number}
				</Pagination.Item>				
			);
		}
		let lastIndex = mappedAgentList.filter(searchingFor(filterRows))
		let filterfield =[];		
		filterfield.push(
		  <tr className='filterRow'>
		  <td><FormControl
		  placeholder="Search AgentId"
		  aria-label="Search"
		  aria-describedby="basic-addon1"
		  id={"agentId"}
		  onChange={(e) => this.handleChange(e)}
		  value={this.state.agentId}
		  /></td>
		  <td><FormControl
		  placeholder="Search AgentName"
		  aria-label="Search"
		  aria-describedby="basic-addon1"
		  id={"agentName"}
		  onChange={(e) => this.handleChange(e)}
		  value={this.state.agentName}
		  /></td>
		 <td><FormControl
		  placeholder="Search SupervisorId"
		  aria-label="Search"
		  aria-describedby="basic-addon1"
		  id={"supervisorId"}
		  onChange={(e) => this.handleChange(e)}
		  value={this.state.supervisorId}
		  /></td>
		   <td><FormControl
		  placeholder="Search SupervisorName"
		  aria-label="Search"
		  aria-describedby="basic-addon1"
		  id={"supervisorName"}
		  onChange={(e) => this.handleChange(e)}
		  value={this.state.supervisorName}
		  /></td>
		   <td><FormControl
		  placeholder="Search Region"
		  aria-label="Search"
		  aria-describedby="basic-addon1"
		  id={"regionName"}
		  onChange={(e) => this.handleChange(e)}
		  value={this.state.regionName}
		  /></td>
		 <td><FormControl
		  placeholder="Search Center"
		  aria-label="Search"
		  aria-describedby="basic-addon1"
		  id={"centerName"}
		  onChange={(e) => this.handleChange(e)}
		  value={this.state.centerName}
		  /></td>
		 <td><FormControl
		  placeholder="Search Client"
		  aria-label="Search"
		  aria-describedby="basic-addon1"
		  id={"clientName"}
		  onChange={(e) => this.handleChange(e)}
		  value={this.state.clientName}
		  /></td>
		  <td><FormControl
		  placeholder="Search Process"
		  aria-label="Search"
		  aria-describedby="basic-addon1"
		  id={"processName"}
		  onChange={(e) => this.handleChange(e)}
		  value={this.state.processName}
		  />
			</td>
		  </tr>
		) 
		return(		
			<div>
				<Row>
					<Col>
					<label>Select QA</label>
					</Col>
					<Col>
					<Picky keepOpen={false}
					value={this.state.selectedauditors}
					options={_.cloneDeep(this.props.auditorList)}
					onChange={this.handleSelectAuditors}
					open={false}
					valueKey="employeeId"
					labelKey="firstName"
					multiple={false}
					includeSelectAll={true}
					includeFilter={true}
					clearFilterOnClose={true}
					placeholder='QA'
					dropdownHeight={600}
					/>
				</Col>
				</Row> 
				<br/>			
				<Row><Col><center><Button onClick={this.showMappedAgents} className='buttonwidth' size='md'
				disabled={!this.validateButton()}>List Agents</Button>&nbsp;
				<Button className='buttonwidth' onClick={this.reset}>Reset</Button>
       </center></Col>
			 </Row>
				{ show === true ?
				<div>
				<span className='alignRight marginRightten'><b>Count - {lastIndex.length}</b></span>
				<Table responsive>
					<thead>
						<tr>
						<th><i class="fas fa-filter filterReport" onClick={this.handleFilter}/> AGENT ID</th>
						<th>AGENT NAME</th>
						<th>SUPERVISOR ID</th>
						<th>SUPERVISOR NAME</th>
						<th>REGION</th>
						<th>CENTER</th>
						<th>CLIENT</th>
						<th>PROCESS</th>
						</tr>
						{showFilter ? filterfield : null}
					</thead>				
				 <tbody>
				 	{(!_.isEmpty(mappedAgentList)) ?
            _.map(mappedAgentList.filter(searchingFor(filterRows)), (val, i) =>{
              if(i >= startOffset & startCount < Per_Page){
								startCount++;							
              return(
                <tr>
								<td>{val.agentId}</td>
								<td>{val.agentName}</td>
								<td>{val.supervisorId}</td>
								<td>{val.supervisorName}</td>
								<td>{val.regionName}</td>
								<td>{val.centerName}</td>
								<td>{val.clientName}</td>
								<td>{val.processName}</td> 
                </tr>                
              )
              }
            }) :
            <tr><td colSpan='8'>No Agents Mapped</td></tr>
            }
				 </tbody>
				 </Table>
				 <br/>
				 <Pagination>
				 <Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
				 <Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
					 {items[activePage-1]}
					 {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
					 {items[activePage+1]}
				 <Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
				 <Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
				 </Pagination> 
				 </div>
				 : null
				}			
		
			</div>
		 )
    }
}